import React from 'react';

import Backdrop from '../../common/components/UI/Backdrop/Backdrop';
import Snackbar from '../../common/components/UI/Snackbar/Snackbar';
class EmploymentBillboard extends React.Component {
    render() {
        return (
            <React.Fragment>
                {this.props.children}
                <Backdrop
                    showSpinner={this.props.spinnerShow}
                    showBack={this.props.spinnerShow}
                />
                <Snackbar
                    type={this.props.typeSnackbar}
                    message={this.props.messageSnackbar}
                    open={this.props.openSnackbar}
                    closeSnackbar={this.props.closeSnackbar}
                    bodyStyle={{ whiteSpace: 'pre-line' }}
                />
            </React.Fragment>
        )
    }
}

export default EmploymentBillboard;